import imgCaelus91 from "./img-caelus9 (1).webp";
import imgCaelus92 from "./img-caelus9 (2).webp";
import imgCaelus93 from "./img-caelus9 (3).webp";

const imgCaelus9 = [imgCaelus91, imgCaelus92, imgCaelus93];

export default imgCaelus9;
